// Ids of the product page's sections that other sections link or scroll to.

export const QUESTIONS_SECTION_ID = "questions";

export const REVIEWS_SECTION_ID = "reviews";

export const REVIEWS_HEADING_ID = "reviews-heading";

export const SELLER_OPTIONS_SECTION_ID = "all-seller-options";
